import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataSourceService } from './data-source-service.ts';
import { SubscriberUpdateDto } from '../dtos/subscribe/subscriberUpdateDto.js';

@Injectable({
  providedIn: 'root'
})
export class SubscribeService {

  constructor(
    private http: HttpClient,
    private dataSourceService: DataSourceService
  ) { }

  private apiUrl = `${environment.apiUrl}/Subscriber`;
  public apiUrlSmtp = `${environment.apiUrl}/smtps`;

  update(id: number, subscriberUpdateDto: SubscriberUpdateDto) {
    return this.http.put(`${this.apiUrl}/${id}`, subscriberUpdateDto)
  }

  delete(id:number): Observable<any>{
    return this.http.delete(`${this.apiUrl}/${id}`)
  }
  
  async getListSubscriber(): Promise<CustomStore<any, any>> {
    return this.dataSourceService.getDataSource(this.apiUrl)
  }

  sendSubscriberMail(emails: any[], templateName:string) {
    return this.http.post(`${this.apiUrlSmtp}/SendSubscriberMail?templateName=${templateName}`, emails)
  }

}
